import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PlayerDetailsPageRoutingModule } from './player-details-routing.module';

import { PlayerDetailsPage } from './player-details.page';
import { MatchListModule } from '../matches/match-list/match-list.module';
import { TranslateModule } from '@ngx-translate/core';
import { PlayerNumberComponent } from '../player-number/player-number.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        PlayerDetailsPageRoutingModule,
        MatchListModule,
        TranslateModule.forChild(),
        PlayerNumberComponent
    ],
    declarations: [PlayerDetailsPage]
})
export class PlayerDetailsPageModule { }
